<template>
  <el-drawer title="我是标题"
             :with-header="false"
             :visible.sync="drawer"
             size="57%"
             class="drawerMain"
             :direction="direction"
             :before-close="handleClose">
    <el-container class="container">
      <el-aside class="containerLeft">
        <div>
          我的菜单：
        </div>
        <el-scrollbar class="scroll-bar">
          <el-col :span="6"
                  class="nameList"
                  style="height:60px;border:1px solid red;margin:10px "
                  v-for="(item, index) in NameList"
                  :key="index">
            <div class="grid-content bg-purple"> {{ item.name }}</div>
          </el-col>
        </el-scrollbar>

      </el-aside>
      <el-container class="containerMain">
        <el-header>
          <span>
            功能名称：
          </span>
          <el-input placeholder="请输入搜索关键字"
                    v-model="searchText"
                    style="width:80%"
                    clearable>
          </el-input>
          <el-button type="primary"
                     icon="el-icon-search">查询</el-button>
        </el-header>
        <el-main>
          <el-scrollbar class="scroll-bar">
            <el-collapse v-model="activeNames"
                         accordion
                         class="collapseMain"
                         @change="handleChange">
              <el-collapse-item title="一致性 Consistency"
                                v-for="(item,index) in changNameList"
                                :key="index"
                                name="1">
                <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
              </el-collapse-item>
            </el-collapse>
          </el-scrollbar>

        </el-main>
        <el-footer>
          <div class="demo-drawer__footer">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary"
                       @click="$refs.drawer.closeDrawer()"
                       :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
          </div>
        </el-footer>
      </el-container>
    </el-container>

  </el-drawer>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      searchText: '',
      changNameList: [
        { name: "测试单位1", value: "0" },
        { name: "测试单位1", value: "1" },
        { name: "测试单位1", value: "2" },
        { name: "测试单位1", value: "3" },
        { name: "测试单位1", value: "4" },
        { name: "测试单位1", value: "5" },

      ],
      NameList: [
        { name: "测试单位1", value: "0" },
        { name: "测试单位2", value: "0" },
        { name: "测试单位3", value: "0" },
        { name: "测试单位4", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位5", value: "0" },
        { name: "测试单位8", value: "0" },
        { name: "测试单位9", value: "0" },
        { name: "测试单位10", value: "0" },
        { name: "测试单位11", value: "0" },
        { name: "测试单位12", value: "0" },
      ],
      activeNames: [],
      drawer: false,
      direction: 'ttb',

    }
  },
  methods: {
    handleChange () { },
    handleClose () { },
    cancelForm () { },
  }
}
</script>
<style scoped lang="scss">
.drawerMain {
  .container {
    padding: 10px;
    .containerLeft {
      width: 350px;
      // height: 416px;
      // overflow: auto;
      .scroll-bar {
        height: 400px;
      }
    }
    .containerMain {
      .scroll-bar {
        height: 290px;
      }
      .collapseMain {
        // height: 290px;
        // overflow: auto;
      }
    }
  }
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 40px;
  height: 42px !important;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  // text-align: center;
  // line-height: 300px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 260px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>